import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';

@Component({
    selector: 'abc-graphics-movenode-controller',
    templateUrl: './movenode-controller.component.html',
    styleUrls: ['./movenode-controller.component.scss'],
    standalone: false
})
export class MovenodeControllerComponent implements AfterViewInit, OnInit {
  @ViewChild('controllerContainer', { static: false }) controllerContainer: ElementRef;
  @Output() cancelMoveNodeAction = new EventEmitter();

  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;

  constructor(private resourceService: ResourceManagerService) {
    this.resAsync = this.resourceService.getResourceSet('abc-graphics-adapters-open-layers');
  }

  async ngOnInit() {
    this.res = await this.resAsync;
  }

  ngAfterViewInit() {
    this.setVisible(false);
  }

  setVisible(visible: boolean): void {
    if (this.controllerContainer && this.controllerContainer.nativeElement)
      this.controllerContainer.nativeElement.style.display = visible ? 'block' : 'none';
  }

  cancel() {
    this.setVisible(false);
    this.cancelMoveNodeAction.emit();
  }
}
